import type { ComponentType } from "react";
import { Cog, Sliders, Radio, Link as LinkIcon, AlertCircle, Activity, Wrench } from "lucide-react";

export interface TabIconConfig {
  label: string;
  icon: ComponentType<{ className?: string }>;
}

export const MACHINE_SIDEBAR_TAB_ICONS: Record<string, TabIconConfig> = {
  basic: { label: "Dados básicos", icon: Cog },
  parameters: { label: "Parâmetros", icon: Sliders },
  sensors: { label: "Sensores", icon: Radio },
  compatibilities: { label: "Compatibilidades", icon: LinkIcon },
  alarms: { label: "Alarmes", icon: AlertCircle },
  operation: { label: "Operação", icon: Activity },
  advanced: { label: "Ações avançadas", icon: Wrench },
};
